import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { JobsDashboard } from '@enrich/shared-lib';

export const Jobs = () => {
    const { companySlug } = useParams();
    const location = useLocation();
    const initialStatusFilter = location.state?.statusFilter;

    return (
        <JobsDashboard
            companySlug={companySlug}
            showAdminActions={false}
            showCreateJobAction={true}
            createJobPath={`/${companySlug}/jobs/create`}
            showCompanyColumn={false}
            initialStatusFilter={initialStatusFilter}
        />
    );
};
